export const LOADING_USERS = 'LOADING_USERS'
export const GET_USERS = 'GET_USERS'
export const FILTER_USERS = 'FILTER_USERS'
